// ----------------------------------------------------------------------

export default function FormLabel(theme) {
    return {
        MuiFormLabel: {
            styleOverrides:{
                asterisk: {
                    color: 'red',
                    '&$error': {
                        color: 'red'
                    },
                }
            }
            
        }
    };
}
